import { useApi } from './use-api-call';
import { LicenseDTO } from './license-api';
import { ProductDTO } from './product-api';
import { UserDTO } from './user-api';


export const useSearchRedeemCodeApi = () => useApi<{ 
redeemCodes: RedeemCodeDTO[];
        licenses: LicenseDTO[];
        products: ProductDTO[];
        users: UserDTO[];
        allowEdit: boolean; 
    }>('/redeem-code/search-redeem-code');

export const useGetRedeemCodeApi = () => useApi<{ redeemCode: RedeemCodeDTO; allowEdit: boolean; }>('/redeem-code/get-redeem-code/{id}');

export const useSaveRedeemCodeApi = () => useApi<{ redeemCode: RedeemCodeDTO}>('/redeem-code/save-redeem-code');

export const useDeleteRedeemCodeApi = () => useApi('/redeem-code/delete-redeem-code/{id}');

export interface RedeemCodeDTO { 
id?:number;
code:string;
productId:number;
used:boolean;
usedBy:string;
usedAt:Date;
licenseSerial:number;
}
